import React from "react";

const FacebookIcon = () => {
  return (
    <div>
      <svg
        width="30"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_480_1433)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18 9.05304C18 4.05318 13.9706 0 9 0C4.02943 0 0 4.05318 0 9.05304C0 13.5717 3.29117 17.317 7.59375 17.9961V11.6699H5.30859V9.05304H7.59375V7.05855C7.59375 4.78963 8.93739 3.53635 10.9932 3.53635C11.9779 3.53635 13.0078 3.71316 13.0078 3.71316V5.94106H11.8729C10.7549 5.94106 10.4062 6.63891 10.4062 7.35484V9.05304H12.9023L12.5033 11.6699H10.4062V17.9961C14.7088 17.317 18 13.5717 18 9.05304Z"
            fill="#1877F2"
          />
        </g>
        <defs>
          <clipPath id="clip0_480_1433">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default FacebookIcon;
